import { css } from '@/styled-system/css';

export const photoCarouselNavControlsStyles = css.raw({
  // Make sure the nav controls are visible above the photos but
  // don't prevent users from being able to click the photos.
  position: 'static',
  zIndex: 1,
});
